export const formatCognitoName = (
  givenName: string | undefined,
  surname: string | undefined
): string => {
  if (givenName && surname) {
    const formattedGivenName = givenName
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')

    const formattedSurname = surname
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')

    const fullName = `${formattedGivenName} ${formattedSurname}`
    return fullName
  }
  return 'NA'
}

export const transformCameCaseCognitoName = (
  value: string | undefined
): string | undefined => {
  if (value) {
    return value
      .toLowerCase()
      .replace(/(^\w{1})|(^\W{1})|(\s+\w{1})|(\s+\W{1})/g, (letter) =>
        letter.toUpperCase()
      )
  }
  return undefined
}

export const formatLoginNetworkCognito = (email: string): string => {
  const [login] = email.split('@')
  return login.toLowerCase()
}
